import React, { Component } from 'react';
import {NavLink as RouterNavLink, Link} from 'react-router-dom';
import FontAwesome from 'react-fontawesome';
import {Button, Collapse} from 'reactstrap'; //, Modal, ModalHeader, ModalBody, ModalFooter
import malmabLogo from '../../static/malmab.png';
import modLogo from '../../static/mod.png';
import styles from './MainMenu.css';
import Logic from '../../Logic';

class MainMenu extends Component {

    constructor(props) {
        super(props);
        this.logic = new Logic();
        this.toggle = this.toggle.bind(this);
        // this.toggleModal = this.toggleModal.bind(this);
        this.state = { collapse: true, modal: false };
      }
    
    toggle() {
        this.setState(state => ({ collapse: !state.collapse }));
    }

    // toggleModal() {
    //     this.setState(prevState => ({
    //       modal: !prevState.modal
    //     }));
    //   }

    render(){
        return (
            <>
            {this.props.init.user || this.props.init.admin || this.props.init.candidate ?
             <nav className="navbar navbar-expand-lg navbar-dark" style={{backgroundColor:'#466FB9', color:'white'}}> 
                
                <Button className="navbar-toggler" onClick={this.toggle}><span className="navbar-toggler-icon"></span></Button>
                <Link to={this.props.init.user ? '/mycandidates' : this.props.init.candidate ? '/edit' : '/users'}>
                    <div style={{marginRight:'auto'}}>
                        {/* <img src={malmabLogo} style={{height:'50px', float:'right', borderLeft:'1px solid white', paddingLeft:'1rem'}} alt="מלמב"/> */}
                        <img src={modLogo} style={{height:'50px', float:'left', marginRight:'1rem'}} alt="משרד הביטחון"/>
                    </div>
                </Link>

                <Collapse isOpen={this.state.collapse} className="navbar-collapse" id="navbar">
                    <ul className="navbar-nav">

                        {this.props.init.user ? 
                        <>
                        <li className="nav-item">
                            <RouterNavLink className="nav-link" to="/mycandidates">המועמדים שלי<span className="sr-only">(current)</span></RouterNavLink>
                        </li>
                        </> : null}

                        {this.props.init.admin ? 
                        <>
                        <li className="nav-item">
                            <RouterNavLink className="nav-link" to="/users">ניהול נאמני ביטחון</RouterNavLink>
                        </li>
                        
                        {/* <li className="nav-item">
                            <RouterNavLink className="nav-link" to="/report">דוח מצב</RouterNavLink>
                        </li> */}
                        </> : null}

                        {this.props.init.candidate && this.props.validSms ?
                            <RouterNavLink className="nav-link" to="/edit">שאלון מועמדים</RouterNavLink> 
                        : null}
                        
                    </ul>


                    <div className="mr-auto d-md-block d-none">
                        <a className="help-button" href={this.logic.getApiBaseUrl() + "/Forms/user-pc.pdf"} download>מדריך למשתמש</a>
                        {/* onClick={this.toggleModal} */}
                        {this.props.init.user ? 
                        <span className="username order-right">שלום, {this.props.init.user.fullName} {this.props.init.verbose ? '[נאמן ביטחון]' : null}</span>
                        : this.props.init.admin ?
                        <span className="username order-right">שלום, {this.props.init.admin.fullName} {this.props.init.verbose ? '[מנהלן]' : null}</span>
                        :<span className="username order-right">שלום, {this.props.init.candidate.firstName} {this.props.init.candidate.lastName} {this.props.init.verbose ? '[מועמד]' : null}</span>}
                    </div>

                    <div className="ml-auto d-md-none d-block col-xs-12">
                        {this.props.init.user ? 
                        <span className="username col-xs-4 float-right">שלום, {this.props.init.user.fullName} {this.props.init.verbose ? '[נאמן ביטחון]' : null}</span>
                        : this.props.init.admin ?
                        <span className="username col-xs-4 float-right">שלום, {this.props.init.admin.fullName} {this.props.init.verbose ? '[מנהלן]' : null}</span>
                        :<span className="username col-xs-4 float-right">שלום, {this.props.init.candidate.firstName} {this.props.init.candidate.lastName} {this.props.init.verbose ? '[מועמד]' : null}</span>}
                        {/* <div className="col-xs-4 float-right">&nbsp;</div> */}
                        <div className="clearfix"></div>
                        <a className="help-button col-xs-4" style={{marginBottom:'1rem',marginTop:'1rem'}} href={this.logic.getApiBaseUrl() + "/Forms/user-mobile.pdf"} download>מדריך למשתמש</a>
                        {/* onClick={this.toggleModal} */}
                    </div>

                </Collapse>
            </nav> : null}

            {/* <Modal isOpen={this.state.modal} toggle={this.toggleModal} className={"modal-close " + this.props.className}>
                <ModalHeader toggle={this.toggleModal}>מדריך למשתמש</ModalHeader>
                <ModalBody>
                    {this.props.init.user ? 
                    <p>
                    מדריך למשתמשים
                    </p> 
                    : null}
                    
                    {this.props.init.candidate ?
                    <p>
                    מדריך למועמדים
                    </p>
                    : null}

                    {this.props.init.admin ?
                    <p>
                    מדריך ניהול נאמני ביטחון מלמ"ב
                    </p>
                    : null}
                </ModalBody>
                <ModalFooter>
                    <Button color="secondary" onClick={this.toggleModal}>סגור</Button>
                </ModalFooter>
            </Modal> */}

            </>
        );
    }
  };
  
export default MainMenu;